import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestResponse } from '../intefaces/requestResponse';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService extends BaseService {

    constructor(protected http: HttpClient) {
        super();
    }

    public deleteInvoiceDetails(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('deleteInvoiceDetails'), { id: id });
    }

    public updateInvoiceDetails(data: any){
        return this.http.post<RequestResponse>(this.getUrl('updateInvoiceDetails'), data);
    }

    public addInvoiceDetails(data: any){
        return this.http.post<RequestResponse>(this.getUrl('addInvoiceDetails'), data);
    }

    public getInvoiceDetails(){
        return this.http.get<RequestResponse>(this.getUrl('getInvoiceDetails'));
    }

    public getAllInvoices(params){
        return this.http.post<RequestResponse>(this.setUrl('invoices/all'), params);
    }

    public getManualInvoices() {
        return this.http.get<RequestResponse>(this.setUrl('manualInvoices'));
    }

    public getPrepaidManualInvoices() {
        return this.http.get<RequestResponse>(this.getUrl('prepaidManualInvoices'));
    }

}
